export default {
    error: "error",
    warning: "warning",
    info: "info",
    success: "success",
    
}